<!-- Timesheet Entry Form -->
<button mat-raised-button color="primary" (click)="exportTimesheet()" type="button" class="excel-export-button" [disabled]="isExcelExporting"> @if(isExcelExporting === true){<span class="spinner-size"><mat-spinner [diameter]="20"></mat-spinner></span>}{{exportButtonText}}</button>
<form [formGroup]="timesheetForm" (ngSubmit)="onSubmit()" class="timesheet-form" *ngIf="!isAdmin">
  <div class="head">
    <h2 class="timesheet-title">Timesheet Entry</h2>
  </div>
  <div class="form-row">
    
    <div class="field">
      <mat-form-field appearance="outline" class="work-date-field" [class.has-error]="timesheetForm.get('workDate')?.invalid && timesheetForm.get('workDate')?.touched && !submittedSuccessfully">
        <mat-label>Work Date</mat-label>
        <input matInput [matDatepicker]="workDatePicker" [max]="today" [min]="minDate"formControlName="workDate" required>
        <mat-datepicker-toggle matSuffix [for]="workDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #workDatePicker></mat-datepicker>
        <mat-error *ngIf="timesheetForm.get('workDate')?.invalid && timesheetForm.get('workDate')?.touched && !submittedSuccessfully">
          Work Date is required
        </mat-error>
      </mat-form-field>
    </div>
    
    <!-- Category Selection -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>Category</mat-label>
        <mat-select formControlName="categoryId" (selectionChange)="onCategorySelection($event.value)" required>
          <mat-option>
            <ngx-mat-select-search
            [formControl]="categorySearch.filterCtrl"
            [noEntriesFoundLabel]="'No Category Found'"
            [placeholderLabel]="'Category'"
            ></ngx-mat-select-search>
          </mat-option>
          @for (category of categorySearch.filteredOptions | async; track category) {
            <mat-option [value]="category.id" >{{category.name}}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="timesheetForm.get('categoryId')?.invalid && timesheetForm.get('categoryId')?.touched">
          Category is required
        </mat-error>
      </mat-form-field>
    </div>
    
    <!-- Activity Selection -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>Activity</mat-label>
        <mat-select formControlName="activityId" required>
          <mat-option>
            <ngx-mat-select-search
            [formControl]="activitySearch.filterCtrl"
            [noEntriesFoundLabel]="'No Activity Found'"
            [placeholderLabel]="'Activity'"
            ></ngx-mat-select-search>
          </mat-option>
          @for (activity of activitySearch.filteredOptions | async; track activity) {
            <mat-option [value]="activity.id" >{{activity.name}}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="timesheetForm.get('activityId')?.invalid && timesheetForm.get('activityId')?.touched">
          Activity is required
        </mat-error>
      </mat-form-field>
    </div>
    
    <!-- No Of Hours Field -->
    <div class="field">
      <mat-form-field appearance="outline">
        <mat-label>Number Of Hours</mat-label>
        <input type="number" step="0.1" min="0.1" max="10" matInput formControlName="noOfHours" required>
        <!-- <mat-error *ngIf="timesheetForm.get('noOfHours')?.invalid && timesheetForm.get('noOfHours')?.touched"> -->
          <mat-error *ngIf="timesheetForm.get('noOfHours')?.errors?.['required'] && timesheetForm.get('noOfHours')?.touched">
          Number Of Hours is required
        </mat-error>
        <mat-error *ngIf="timesheetForm.get('noOfHours')?.errors?.['max']">Hours Shoud Be Less Than Or Equal To 10</mat-error>
        <mat-error *ngIf="timesheetForm.get('noOfHours')?.errors?.['maxTwoDecimalPlaces']">
          Hours can have a maximum of two decimal places.
        </mat-error>
      </mat-form-field>
    </div>
    
    <!-- Description or  Work Done Field -->
    <div class="field">
      <mat-form-field appearance="outline" class="work-done-field">
        <mat-label>Description</mat-label>
        <!-- <input matInput type="text" formControlName="workDone"> -->
         <textarea
         matInput
         cdkTextareaAutosize
         #autosize="cdkTextareaAutosize"
         cdkAutosizeMaxRows="10"
         maxlength="255"
         formControlName="workDone">
         </textarea>
      </mat-form-field>
    </div>
    <button  mat-raised-button color="primary"type="submit" [disabled]="isSubmitting">
  Submit
</button>
  </div>
</form>
<app-timesheet-list (isExcelBeingDownloaded)="excelExportButtonStatus($event)" ></app-timesheet-list>